import styled from "styled-components";
import { motion } from "framer-motion";

export const ContainerNumeroAfiliado = styled(motion.div)`
  height: calc(100dvh - 20dvh);
  display: flex;
  justify-content: center;
  overflow-y: auto;
  overflow-x: hidden;
  .content {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-direction: column;
    margin-top: 20px;
    gap: 30px;
  }
  span {
    width: 90%;
    font-size: 18px;
    font-weight: 400;
    color: var(--color-latex10);
    text-align: center;
    line-height: 200%;
  }
  .bold {
    font-size: 18px;

    font-weight: 700;
    color: var(--color-latex10);
  }

  button {
    width: 150px;
    height: 42px;
    border-radius: 4px;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 10px;
    font-weight: bold;
    font-size: 18px;
  }
  .container-btn {
    display: flex;
    gap: 30px;
    padding-bottom: 10px;
  }
  .nroAfiliado-input {
    border-radius: 8px;
    border: 4px solid var(--color-latex10);
    padding-left: 10px;
    color: var(--color-latex10);
  }
`;
